import bem from 'utils/bem';

export const block = bem('new-project-selector');
